import React, { useEffect, useRef } from 'react';
import { useCall } from './CallContext';

export const IncomingCallPopup = () => {
  const { incomingCall, acceptCall, rejectCall } = useCall();
  const audioRef = useRef(null);

  useEffect(() => {
    // Attempt to unlock audio immediately on mount if user clicks anywhere
    const handleInteraction = () => {
      if (audioRef.current) {
        audioRef.current.play().then(() => {
          audioRef.current.pause();
        }).catch(() => {});
      }
      document.removeEventListener('click', handleInteraction);
    };
    document.addEventListener('click', handleInteraction);

    return () => document.removeEventListener('click', handleInteraction);
  }, []);

  useEffect(() => {
    if (incomingCall && incomingCall.status === "ringing") {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => console.warn("Autoplay blocked: User interaction required."));
        }
      }
    } else {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }
  }, [incomingCall]);

  const handleAccept = () => {
    // ✅ Directly accept call without navigation
    acceptCall();
  };

  if (!incomingCall || incomingCall.status !== "ringing") return null;

  return (
    <>
      <audio ref={audioRef} src="https://res.cloudinary.com/dncifl1ql/video/upload/v1781458593/ringtone_call_eovric.mp3" loop />
      <div className="fixed top-4 right-4 md:right-8 bg-[#1f1a3a] p-4 md:p-6 rounded-2xl shadow-2xl shadow-indigo-500/50 border border-indigo-500 z-[9999] w-80">
        
        <div className="flex flex-col items-center">
          <h2 className="text-white text-lg font-semibold mb-1">
            Incoming {incomingCall.type} Call
          </h2>

          <p className="text-gray-300 text-sm mb-4">
            {incomingCall.fromName || "Unknown Caller"}
          </p>

          <div className="flex gap-4 w-full justify-center">
            <button
              className="flex-1 py-2 bg-green-600 hover:bg-green-500 text-white rounded-lg font-medium transition-colors"
              onClick={handleAccept}
            >
              Accept
            </button>

            <button
              className="flex-1 py-2 bg-red-600 hover:bg-red-500 text-white rounded-lg font-medium transition-colors"
              onClick={rejectCall}
            >
              Reject
            </button>
          </div>
        </div>
      </div>
    </>
  );
};